export function formatClientDocument(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function normalizeClientDocument(value: string) {
  return value.replace(/\D/g, "");
}

export function formatClientSecondary(document?: string | null) {
  if (!document) return "Cliente";
  return `Cliente • ${formatClientDocument(document)}`;
}

export function getClientDocumentLabel(document?: string | null) {
  return document ? formatClientDocument(document) : "";
}

export function getValidClientOffset(
  total: number,
  offset: number,
  pageSize: number,
) {
  if (total <= 0) return 0;
  const lastOffset = Math.floor((total - 1) / pageSize) * pageSize;
  return Math.min(Math.max(0, offset), lastOffset);
}
